import { Messages } from '../../../../codegen/Localize';
import { ILanguage } from '../../../../httpClient/serverApi/types/ILanguage';
import WebHttpClient from '../../../../httpClient/WebHttpClient';
import { GetLanguagesRequest } from '../../serverApi/requests/unownedSettings/GetLanguagesRequest';


export class Languages {

  public getAll(): Promise<ILanguage[]> {
    return WebHttpClient.sendRequest(new GetLanguagesRequest()).then(result => result.languages);
  }

  // a special value for the user language that indicates that we should use the server language
  public unspecifiedLanguage(): ILanguage {
    return {
      displayName: Messages.unspecified(),
      language: null,
      locale: null
    };
  }

}

export const LanguagesInstance = new Languages();